import React, { useState } from 'react';
import { ChevronDown, Eye, History } from 'lucide-react';
import { dataIt } from '../haccpApi';
import { EliminaDocumento } from './EliminaDocumento';

// Analisi e tamponi (scelta utente): i precedenti restano, ognuno si può vedere o eliminare
export const StoricoDocumento = ({ v, onVedi, onEliminato }) => {
  const [aperto, setAperto] = useState(false);
  if (!v.storico?.length) return null;
  const testid = `documenti-voce-${v.codice}-storico`;
  return (
    <div>
      <button onClick={() => setAperto(!aperto)} data-testid={`${testid}-toggle`} className="text-xs text-gray-600 font-medium flex items-center gap-1">
        <History className="h-3.5 w-3.5" />Versioni precedenti ({v.storico.length})
        <ChevronDown className={`h-3.5 w-3.5 transition-transform ${aperto ? 'rotate-180' : ''}`} />
      </button>
      {aperto && (
        <div className="mt-1.5 space-y-1.5" data-testid={`${testid}-elenco`}>
          {v.storico.map((d) => {
            const nome = `${v.nome}${d.data_documento ? ` del ${dataIt(d.data_documento)}` : ''}`;
            return (
              <div key={d.id} className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-dashed border-gray-300 p-2" data-testid={`documenti-storico-${d.id}`}>
                <span className="text-xs text-gray-700">{d.data_documento ? `Del ${dataIt(d.data_documento)}` : 'Senza data'}</span>
                <div className="flex gap-1.5">
                  {d.file && <button onClick={() => onVedi(d, nome)} data-testid={`documenti-storico-${d.id}-vedi`}
                    className="h-9 px-3 rounded-lg border border-gray-300 bg-white text-xs text-gray-700 flex items-center gap-1"><Eye className="h-3.5 w-3.5" />Vedi</button>}
                  <EliminaDocumento documento={d} nome={nome} onEliminato={onEliminato} testid={`documenti-storico-${d.id}-elimina`} />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
